import { ApolloClient } from '@apollo/client'
import gql from 'graphql-tag'

export const REVOKE_TEST_REGISTRATION_KEY = gql`
  mutation RevokeTestRegistrationKey($input: RevokeTestRegistrationKeyInput!) {
    revokeTestRegistrationKey(input: $input) {
      id
    }
  }
`

export const REVOKE_REGISTRATION_KEY_BY_OWNER = gql`
  mutation RevokeTestRegistrationKeyByOwner($owner: String!) {
    revokeTestRegistrationKeyByOwner(owner: $owner) {
      owner
    }
  }
`

export async function revokeTestRegistrationKey(
  id: string,
  client: ApolloClient<unknown>,
): Promise<void> {
  await client.mutate<{
    revokeTestRegistrationKey: boolean
  }>({
    mutation: REVOKE_TEST_REGISTRATION_KEY,
    variables: {
      input: {
        id,
      },
    },
  })
}

export async function revokeTestRegistrationKeyByOwner(
  id: string,
  client: ApolloClient<unknown>,
): Promise<void> {
  await client.mutate<{
    revokeTestRegistrationKeyByOwner: { owner: string }
  }>({
    mutation: REVOKE_REGISTRATION_KEY_BY_OWNER,
    variables: {
      owner: id,
    },
  })
}
